import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Search } from 'src/@core/interfaces/search';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { entityTypes } from 'src/app/shared/helpers/roles-permissions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'hour4u-admin-attendance-sheet',
  templateUrl: './attendance-sheet.component.html',
  styleUrls: ['./attendance-sheet.component.scss']
})
export class AttendanceSheetComponent implements OnInit {
  @Input() data: any;
  attendanceDataSource: any[] = [];
  columns = [
    { columnDef: 'name', visible: true, label: 'Name of applicant' },
    { columnDef: 'workorder', visible: true, label: 'Workorder' },
    { columnDef: 'city', visible: true, label: 'City' },
    { columnDef: 'status', visible: true, label: 'Status' },
    { columnDef: '12hrFollowup', visible: true, label: '12 hours follow-up' },
    { columnDef: '2hrFollowup', visible: true, label: '2 hours follow-up' },
    { columnDef: 'inTime', visible: true, label: 'In time' },
    { columnDef: 'outTime', visible: true, label: 'Out time' },
    { columnDef: 'hoursWorked', visible: true, label: 'Hour worked' },
    { columnDef: 'totalTasks', visible: true, label: 'Total Tasks' },
  ];
  multiselectOptions = [
    // { value: 'Approved', label: 'Approved' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Active', label: 'Active' },
    { value: 'Rejected', label: 'Rejected' }
  ];
  selectedWorkorderStatus: any = "";
  displayedColumns = [...this.columns.map(x => x.columnDef)];
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  searchByName: any = null;
  timeoutRef: ReturnType<typeof setTimeout>;
  selectedAll: boolean = false;
  selectedTeamMembers = [];
  agenciesList: any[] = [];
  workordersList: any[] = [];
  cityList: any[] = [];
  entityTypes = entityTypes;
  groupByList: any[] = ["workorder"];
  // groupByList: any[] = ["agency", "workorder"];
  selectedGroupBy: any = "workorder";
  searchParams: any[] = [];
  timesheetList: any[] = [];
  selectedAgency: any = null;
  selectedWorkorder: any = null;
  selectedCity: any = null;
  @Output() filterChange = new EventEmitter();
  selectedFollowUpStatus: any = "";
  followUpStatusList: any[] = [
    {
      label: "Going to work",
      value: "GOING_TO_WORK"
    },
    {
      label: "Not Picked",
      value: "NOT_PICKED"
    },
    {
      label: "Busy",
      value: "BUSY"
    },
    {
      label: "Not going to work",
      value: "NOT_GOING_TO_WORK"
    },
    {
      label: "Switched off",
      value: "SWITCHED_OFF"
    },
  ];
  baseImageUrl = environment.image_url;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  resultsLength: number = 0;
  workOrderPage: number = 0;
  workOrderSize: number = 20;
  applicantPage: number = 0;
  applicantSize: number = 20;

  constructor(
    private dialog: MatDialog,
    private appService: AppService,
    private jobService: JobService,
    private notify: NotificationService
  ) {
  }

  ngOnInit() {
    console.log(this.data);
    this.attendanceDataSource = [];
    this.getAssignedAgenciesAndCreatedByArray();
    this.fetchAttendanceSheetData();
    this.fetchAtendanceFilterData();
  }

  hideColumns() {
    if (this.selectedGroupBy == 'workorder') {
      this.columns = this.columns.map(x => {
        if (x.columnDef == 'workorder' || x.columnDef == 'city')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }

    if (this.selectedGroupBy == 'agency') {
      this.columns = this.columns.map(x => {
        if (x.columnDef == 'workorder' || x.columnDef == 'city')
          x.visible = true;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
  }

  fetchAttendanceSheetData() {
    const jobId = this.data.id;
    this.isLoading = true;
    this.hideColumns();
    this.searchParams = [];
    if (jobId) {
      if (this.searchByName) {
        this.searchParams.push(new Search('jobSeekerName', this.searchByName));
      }
      if (this.selectedAgency && this.selectedAgency.length) {
        this.selectedAgency.forEach(element => {
          this.searchParams.push(new Search("agencyId", element));
        });
      }
      if (this.selectedWorkorder && this.selectedWorkorder.length) {
        this.selectedWorkorder.forEach(element => {
          this.searchParams.push(new Search("workOrderId", element));
        });
      }
      if (this.selectedCity && this.selectedCity.length) {
        this.selectedCity.forEach(element => {
          this.searchParams.push(new Search("city", element));
        });
      }
      if (this.selectedFollowUpStatus && this.selectedFollowUpStatus.length) {
        this.selectedFollowUpStatus.forEach(element => {
          this.searchParams.push(new Search("followUpStatus", element));
        });
      }
      if (this.selectedWorkorderStatus && this.selectedWorkorderStatus.length) {
        this.selectedWorkorderStatus.forEach(element => {
          this.searchParams.push(new Search("status", element));
        });
      }
      const sortField = 'createdOn';
      const sortOrder = 'desc';
      // const workOrderPage = 0;
      // const workOrderSize = 10;
      this.jobService.getTimesheetData(
        jobId,
        this.selectedGroupBy,
        this.workOrderPage,
        this.workOrderSize,
        this.applicantPage,
        this.applicantSize,
        sortField,
        sortOrder,
        this.searchParams
      ).subscribe((res: any) => {
        console.log(this.columns)
        this.isLoading = false;
        this.timesheetList = res.attendanceResponseList;
        console.log("   this.timesheetList", res, this.timesheetList)
        this.resultsLength = res.totalWorkOrders;
        // this.attendanceDataSource = [];
        if (this.timesheetList && this.timesheetList.length) {
          this.timesheetList.forEach(ele => {
            let obj = {
              agencyDetails: ele.agencyDetails,
              workOrderDetails: ele.workOrderDetails,
              dataSource: ele.attendanceDetails,
              columns: this.columns,
              displayedColumns: this.columns.filter(x => x.visible).map(x => x.columnDef)
            }
            this.attendanceDataSource.push(obj);
          })
          console.log("this.attendanceDataSource---", this.attendanceDataSource)
        }
      }, (err: any) => {
        this.isLoading = false;
        console.log(err)
      })
    } else {
      this.isLoading = false;
    }
  }

  fetchAtendanceFilterData() {
    let cityFilter = "city=true"
    this.jobService.fetchTimesheetFilter(
      this.data.id, cityFilter
    ).subscribe(res => {
      this.cityList = res.cities;
    })

    let workorderFilter = "workorder=true"
    this.jobService.fetchTimesheetFilter(
      this.data.id, workorderFilter
    ).subscribe(res => {
      this.workordersList = res.workOrders;
    })
  }

  getAssignedAgenciesAndCreatedByArray() {
    const entityId = this.profile.entity.id;
    if (entityId) {
      this.jobService.getAssignedAgenciesAndCreatedByArray(entityId
      ).subscribe(data => {
        console.log(data)
        this.agenciesList = data.addedEntityIds;
      }, (error: any) => {
        this.notify.showMessage(error.error.message, 2000);
      });
    } else {
      console.warn('Entity ID is not available. Unable to fetch agencies.');
    }
  }

  selectGroupBy() {
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
    this.hideColumns();
  }

  // clear Search
  clearSearch() {
    this.attendanceDataSource = [];
    this.searchByName = "";
    this.fetchAttendanceSheetData();
  }

  // earch on briefing Form name
  search() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      this.attendanceDataSource = [];
      this.fetchAttendanceSheetData();
    }, 700);
  }

  onFilterChange() {
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
    this.emitFilterData();
  }

  emitFilterData() {
    let params = new HttpParams();

    // Add selected filters to params
    if (this.selectedCity) {
      if (Array.isArray(this.selectedCity)) {
        this.selectedCity.forEach(city => {
          params = params.append('city', city);
        });
      } else {
        params = params.set('city', this.selectedCity);
      }
    }
    if (this.selectedWorkorder) {
      if (Array.isArray(this.selectedWorkorder)) {
        this.selectedWorkorder.forEach(workOrderId => {
          params = params.append('workOrderId', workOrderId);
        });
      } else {
        params = params.set('workOrderId', this.selectedWorkorder);
      }
    }
    if (this.selectedAgency) {
      if (Array.isArray(this.selectedAgency)) {
        this.selectedAgency.forEach(agency => {
          params = params.append('agencyId', agency);
        });
      } else {
        params = params.set('agencyId', this.selectedAgency);
      }
    }
    params = params.set('jobSeekerName', this.searchByName);

    this.filterChange.emit(params);
  }

  // Get Initial letter from JobSeeker name
  getUserNameInitial(full_name) {
    let initialOfName = null;
    if (full_name) {
      if (full_name.split(' ').length == 1) {
        initialOfName = full_name.split(' ')[0].split('')[0];
      }
      if (full_name.split(' ').length > 1) {
        initialOfName = full_name.split(' ')[0].split('')[0] + (full_name.split(' ')[1].split('')[0] ? full_name.split(' ')[1].split('')[0] : '')
      }
      return initialOfName ? initialOfName : full_name.split('')[0];
    }
  }

  clearGroupBySelection(event) {
    console.log(event)
    this.selectedGroupBy = "";
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
  }

  clearAgencySelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedAgency = null;
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
  }

  clearCitySelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedCity = null;
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
  }

  clearWorkorderSelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedWorkorder = null;
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
  }

  clearFollowupStatusSelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedFollowUpStatus = null;
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
  }

  clearStatusSelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedWorkorderStatus = null;
    this.attendanceDataSource = [];
    this.fetchAttendanceSheetData();
  }

  onSelect12hrFollowUp(element: any) {
    console.log(element)
    this.isLoading = true;
    let obj = {
      twelveHourFollowUpStatus: element.twelveHourFollowUpStatus
    }
    if (element && element.jobApplicationId) {
      this.jobService.updateTimeSheetStatus(obj, element.jobApplicationId).subscribe(res => {
        if (res) {
          this.isLoading = false;
          this.notify.showMessage("Follow up status updated successfully!", 2000);
          this.attendanceDataSource = [];
          this.fetchAttendanceSheetData();
        }
      }, (err => {
        this.isLoading = false;
      }))
    }
  }

  onSelect2hrFollowUp(element: any) {
    console.log(element)
    this.isLoading = true;
    let obj = {
      twoHourFollowUpStatus: element.twoHourFollowUpStatus
    }
    if (element && element.jobApplicationId) {
      this.jobService.updateTimeSheetStatus(obj, element.jobApplicationId).subscribe(res => {
        if (res) {
          this.isLoading = false;
          this.notify.showMessage("Follow up status updated successfully!", 2000);
          this.attendanceDataSource = [];
          this.fetchAttendanceSheetData();
        }
      }, (err => {
        this.isLoading = false;
      }))
    }
  }

  showMore() {
    this.workOrderPage++;
    this.fetchAttendanceSheetData()
  }
}
